import { useSalesUnitHourlyRates } from "@/hooks/use-sales-unit-hourly-rates";
import { periodLabel, type DashboardPeriod } from "@/lib/dashboard-period";
import { HourlyRateRankingPanel } from "./HourlyRateRankingPanel";

interface Props {
  period: DashboardPeriod;
  enabled: boolean;
}

export function SalesUnitHourlyRatePanel({ period, enabled }: Props) {
  const { data = [], isLoading, isError } = useSalesUnitHourlyRates(period, enabled);
  if (!enabled) return null;

  return (
    <HourlyRateRankingPanel
      title="Reell timepris per selger"
      subtitle={`Reell GEEK ÷ alle førte timer på prosjekter fullført i ${periodLabel(period)}`}
      entityLabel="Selger"
      dialogDescription={`Kun prosjekter fullført i ${periodLabel(period)}. Reell GEEK og alle førte timer vektes med selgergruppens eierandel.`}
      rows={data.map((row) => ({ ...row, id: row.unitId, name: row.unitName }))}
      isLoading={isLoading}
      isError={isError}
      errorText="Kunne ikke laste reell timepris."
      emptyText="Ingen selgere med fullførte prosjekter i perioden."
      showOwnership
    />
  );
}
